import { FETCH_TYPES } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";
import { fetchTypes } from "../../services/sql/typeGroups";

export const getTypes = (typeGroups, inactive = false) => {
  return dispatch => {
    dispatch(requestTypes(typeGroups, inactive));
    fetchTypes(typeGroups, inactive)
      .then(data => {
        dispatch(receiveTypes(data));
      })
      .catch(err => {
        dispatch(failureTypes(err));
      });
  };
};

export const requestTypes = typeGroups => {
  return {
    type: FETCH_TYPES,
    status: PENDING,
    typeGroups: typeGroups
  };
};

export const failureTypes = err => {
  return {
    type: FETCH_TYPES,
    status: FAILURE
  };
};

export const receiveTypes = data => {
  return {
    type: FETCH_TYPES,
    status: SUCCESS,
    typeGroups: data
  };
};
